const api = {
	login: {
		Authenticate: 'api/Authorize/Authenticate',
		GetCaptcha: 'api/Authorize/GetCaptcha',
		GetEnableRoles: 'api/User/GetEnableRoles',
		ChangePassword: 'api/User/UpdatePassword',//修改密码
		ChangeRole: 'api/Authorize/ChangeRole', //角色登录
		register: 'api/User/register', //判断用户是否为本系统用户
		controlList: '/api/PadScoreCriteria/Pad/Quality/Control/List',
		UserExpireNoticeById: 'api/User/UserExpireNoticeById'//用户到期提醒
	},
	admin: {
		GetModulesByGroup: 'api/user/GetModulesByGroup', //菜单树
		CreateOrUpdateModule: 'api/User/CreateOrUpdateModule', //菜单树增删改
		GetRoles: 'api/User/GetRoles', //角色列表
		CreateOrUpdateRole: 'api/User/CreateOrUpdateRole', //角色增删改
		role2module: 'api/User/role2module', //添加/更新角色权限
		GetRole2Modules: 'api/User/GetRole2Modules', //获取某一角色的权限
		GetList: 'api/User/GetList', //用户管理列表
		CreateOrUpdateUser: 'api/User/CreateOrUpdateUser', //用户管理增删改
		GetRegionsNoHospital: 'api/Region/GetRegionsNoHospital', //区域树
		createorupdate: 'api/Region/createorupdate', //区域树新增修改
		DeleteRegion: 'api/Region/DeleteRegion', //区域树删除
		GetRegionUsers: 'api/Region/GetRegionUsers', //获取区域管理者
		AddRegionUser: 'api/Region/AddRegionUser', //添加区域管理员
		DeleteRegionUser: 'api/Region/DeleteRegionUser', //删除区域管理员
		AddUser2Hospital: 'api/User/AddUser2Hospital', //修改用户归属中心
	},
	user: {
		GetList: 'api/User/GetList' //所有医生
	},
	doctor: {
		GetReporterReportList: 'api/qc/GetReporterReportList',
		UpdateReportReadStatus: 'api/Common/UpdateReportReadStatus',
		GetReportDetail: 'api/qc/GetReportDetail',
		GetReportDetail2: 'api/qc/GetReportDetail2',
		GetDashborad: 'api/doctor/GetDashborad',//审核医生首页
		GetTaskList: 'api/doctor/GetTaskList',//审核医生任务列表
		GetAppealInfoList: 'api/Doctor/GetAppealInfoList', //申诉列表
		CreateAppealInfo: 'api/Doctor/CreateAppealInfo', //发起申诉
		GetAppealDetail: 'api/Doctor/GetAppealDetail', //申诉详情
		CancelAppealInfo: 'api/Doctor/CancelAppealInfo', //取消申诉
		AdmitAppeal: 'api/Doctor/AdmitAppeal',
		GetImagesClone: 'api/qc/GetImagesClone' //拉取影像
	},
	experts: {
		GetExpertReportList: 'api/qc/GetExpertReportList',
		CreateOrUpdateQC: 'api/qc/CreateOrUpdateQC',
		CreateOrUpdateQC2: 'api/qc/CreateOrUpdateQC2',
		SaveQCTmp: 'api/qc/SaveQCTmp',
		SaveQCTmp2: 'api/qc/SaveQCTmp2',
		GetDashboradExpert: 'api/expertinfo/GetDashborad',//质控专家首页
		GetTaskList: 'api/expertinfo/GetTaskList',//专家任务列表
		ReturnSamplingReport: 'api/QCAdmin/ReturnSamplingReport', //专家撤回报告
		ExportGetTaskList: 'api/Export/GetTaskList', //导出任务列表
		HospitalQCReport: 'api/Export/HospitalQCReport', //导出任务
		HospitalQCReport2: 'api/Export/HospitalQCReport2', //导出任务
		RescoreAppeal: 'api/expertInfo/RescoreAppeal',//专家重新打分
		RescoreQcadminAppeal: 'api/qcadmin/RescoreAppeal',//仲裁管理员重新打分
		GetAppealRescoresDetail: 'api/Doctor/GetAppealRescoresDetail',//申诉重新打分详情
		RollBackAppealById: 'api/QCAdmin/RollBackAppealById' //撤回申诉上一个状态
	},
	manager: {
		GetCreatedTaskList: 'api/qc/GetCreatedTaskList',
		GetReportListByTask: 'api/qc/GetReportListByTask',
		GetReportListWhere: 'api/qc/GetReportListWhere',
		scoreitem: 'api/scoreitem/GetList',
		scoreitemNew: 'api/ScoreItem/GetQCPlanSoreItemDetailsList',
		qcplan: 'api/qcplan/GetList',
		createorupdate: 'api/scoreitem/createorupdate',
		scoreitemDelete: 'api/scoreitem/delete',
		createorupdateQcplan: 'api/qcplan/createorupdate',
		DeleteQCPlan: 'api/qcplan/DeleteQCPlan',
		GetQCPlan: 'api/qcplan/GetQCPlan',
		cancelList: 'api/qc/cancel',
		GetReportInfo: 'api/QCAdmin/GetReportInfo',//更换报告任务详情
		GetTaskDetail: 'api/qcadmin/GetTaskDetail',//获取任务详情
		GetExpertDistributionDetail: 'api/QCAdmin/GetExpertDistributionDetail',//获取专家分配详情
		GetExpertReportList: 'api/qcadmin/GetExpertReportList', //专家分配报告列表
		GetQCResultsByTask: 'api/qcadmin/GetQCResultsByTask',//任务详情-报告列表-专家列表
		GetDoctorsResult: 'api/qcadmin/GetDoctorsResult', //抽样结果医院/技师
		GetTaskTop5ReduceItem: 'api/Statistics/GetTaskTop5ReduceItem',//抽样任务导出
		SetExportContent: 'api/QCAdmin/SetExportContent',//保存导出内容修改
		GetExportContent: 'api/QCAdmin/GetExportContent',//获取导出内容
		GetUnSelectedDoctors: 'api/QCAdmin/GetUnSelectedDoctors', //获取未抽样报告
		ExportQCReport: 'api/Export/QCReport', //医院报告导出
		GetReportList: 'api/QCAdmin/GetReportList', //抽样报告列表
		// GetSamplingHospitals: 'api/QCAdmin/GetSamplingHospitals', //获取医院
		GetSamplingHospitals: 'api/QCSampling/v1/GetSamplingHospitals', //获取医院
		// GetSamplingDoctors: 'api/QCAdmin/GetSamplingDoctors', //获取医生+报告数量
		GetSamplingDoctors: 'api/QCSampling/v1/GetSamplingDoctors', //获取医生+报告数量
		// GetOneHospitalSampledNum: 'api/QCAdmin/GetOneHospitalSampledNum', //计算抽取份数
		GetOneHospitalSampledNum: 'api/QCSampling/v1/GetOneHospitalSampledNum', //计算抽取份数
		// CreateSampling: 'api/QCAdmin/CreateSampling', //创建任务
		CreateSampling: 'api/QCSampling/v1/CreateSampling', //创建任务
		GetAllHospitals: 'api/Common/GetAllHospitals',
		GetAllRegions: 'api/Region/GetAllRegions', //全部地区
		CreateOrUpdateHospital: 'api/Common/CreateOrUpdateHospital', //影像中心添加修改删除
		GetOneHospital: 'api/Common/GetOneHospital', //影像中心回显
		GetBodyPartDetail: 'api/Common/GetBodyPartDetail', //部位及明细
		GetAppealInfoList: 'api/QCAdmin/GetAppealInfoList', //申诉列表
		ManageAppeal: 'api/ExpertInfo/ManageAppeal', //仲裁专家直接处理
		QCAdminManageAppeal: 'api/QCAdmin/ManageAppeal', //仲裁管理员直接处理
		DistributeAppeal: 'api/QCAdmin/DistributeAppeal', //仲裁管理员转发
		CheckAppeal: 'api/QCAdmin/CheckAppeal', //仲裁管理员审核
		GetAppealExpertList: 'api/ExpertInfo/GetAppealExpertList', //仲裁专家列表
		GetExpertAppealInfoList: 'api/ExpertInfo/GetAppealInfoList', //专家申诉列表	
		UpdateTaskEnable: 'api/QC/UpdateTaskEnable', //逻辑删除抽样任务
		GetExpertScoreStatistic: 'api/QCAdmin/GetExpertScoreStatistic', //专家统计
		GetUserLoginList: 'api/User/GetUserLoginList', //登录统计
		// GetCheckingItems:'api/Common/GetCheckingItems', //获取检查项目
		GetCheckingItems: 'api/Common/GetReportModality', //获取检查项目
		ImportCheckingItem: 'api/Common/ImportCheckingItem', //导入检查项目
		GetScanTypes: 'api/Common/GetScanTypes', //扫描方式
		// GetBodyParts:'api/Common/GetBodyParts', //检查部位
		GetBodyParts: 'api/Common/GetReportBodyPart', //检查部位
		UpdateCheckingItem: 'api/Common/UpdateCheckingItem', //关联检查项目和扫描方式
		SendSMS2Expert: 'api/QCAdmin/SendSMS2Expert', //手动发送短信提醒专家任务已分配
		GetDictionary: 'api/Common/GetDictionary', //获取字典
		GetCanChangableReports: 'api/QCAdmin/GetCanChangableReports', //更换报告列表
		ChangeReports: 'api/QCAdmin/ChangeReports', //更换报告
		GetHospitalUsers: 'api/Common/GetHospitalUsers', //获取中心管理者
		AddHospitalUser: 'api/Common/AddHospitalUser',//添加中心管理者
		DeleteHospitalUser: 'api/Common/DeleteHospitalUser', //删除中心管理员
		GetTaskStatisticByMonth: 'api/QCAdmin/GetTaskStatisticByMonth', //任务按月统计
		UpdateTaskName: 'api/QCAdmin/UpdateTaskName', //修改任务名称
		SendHospitalOk2CD: 'api/QCAdmin/SendHospitalOk2CD', //给中心所有人发送消息
		getTaskDistributeList: 'api/QCAdmin/GetExpertReportUnfinishedBySamplingTaskGuid', // 获取任务重新分发列表
		saveTaskRedistribute: 'api/QCAdmin/SaveResetExpert', // 任务重新分发保存
		getTaskDdistributeDetails: 'api/QCAdmin/GetReportDistributionRecordDetails', // 获取任务分发详情
		getFileInfo: 'api/QCAdmin/GetFileInfo', // 上传文件列表
		FileUpload: 'api/QCAdmin/FileUpload', //上传文件
		DeleteFileById: 'api/QCAdmin/DeleteFileById', //删除上传的文件
		DownFile: 'api/QCAdmin/DownFile',//下载文件
		UpdateFileStatusById: 'api/QCAdmin/UpdateFileStatusById',//设置文件共享
		GetShareFile: 'api/QCAdmin/GetShareFile', //获取共享文件列表
		RollBackExpertTaskByTaskId: 'api/QCAdmin/RollBackExpertTaskByTaskId', //已分配后的撤回
		AddBodyParts: 'api/Common/AddBodyParts', //添加检查部位
		UpdateBodyPartsById: 'api/Common/UpdateBodyPartsById', //删除检查部位
		GetBodyPartsList: 'api/Common/GetBodyPartsList', //获取列表页
		GetCheckItems: 'api/Common/GetCheckItems', //已关联检查项目列表
		ImportReportCheckingItem: 'api/Common/ImportReportCheckingItem', //导入检查项目
		AddContactPartsById: 'api/Common/AddContactPartsById', //关联检查部位
		UpdateUsableCheckById: 'api/Common/UpdateUsableCheckById', //取消
		GetReportModality: 'api/Common/GetReportModality', //设备类型
		GetReportScanType: 'api/Common/GetReportScanType', //获取部位
		GetBodyPartsByModality: 'api/Common/GetBodyPartsByModality',//根据设备Id获取部位
		GetScanTypeByBodyId: 'api/Common/GetScanTypeByBodyId',// 根据设备Id和部位Id获取扫描类型。
		exportHospitals: 'api/Common/exportHospitals', //导出影像中心
		addReportHand: 'api/QCAdmin/AddReportHand', //添加报告
		updateReportHand: 'api/QCAdmin/UpdateReport', //更新手动上传报告
		GetReportHandList: 'api/QCAdmin/GetReport', //获取报告列表
		UploadImageByRptId: 'api/QCAdmin/UploadImageByRptId', // 文件上传，仅支持.zip ,最大不超过1G。
		GetHandReportHospital: 'api/Common/GetHandReportHospital', //获取手动上传报告医院
		GetReportListByCode: 'api/QCAdmin/GetReportListByCode', //获取手动上传报告列表,数据查询接口
		UploadBatchReport: 'api/QCAdmin/UploadReport', // 批量上传报告
		DownloadReportTemplate: 'api/QCAdmin/download/report', // 下载模板
		UploadErrorReport: 'api/QCAdmin/download/error/report', // 上传失败，上传报错信息
		GetReportDetailsByHand: 'api/qcadmin/GetReportDetailsByHand', // 获取手动上传报告详情
		ExportSampleTaskAsync: 'api/Common/ExportSampleTaskAsync', // 抽样任务导出
		ExportPetScoreDeductionDetailsById: 'api/QC/ExportPetScoreDeductionDetailsById' // 抽样任务导出
	},
	specialist: {
		userlist: 'api/ExpertInfo/GetList',
		ExpertInfoDelete: 'api/ExpertInfo/delete',
		ExpertInfoUpdate: 'api/ExpertInfo/CreateOrUpdate',
		GetExpertGroupList: 'api/ExpertGroup/GetExpertGroupList',
		expertsCreateorupdate: 'api/ExpertGroup/createorupdate',
		GetExpertGroup: 'api/ExpertGroup/GetExpertGroup',
		DeleteExpertGroup: 'api/ExpertGroup/DeleteExpertGroup',
		GetExpertJobCount: 'api/qcadmin/GetExpertJobCount', //质控管理员查看专家工作量
		UploadPic: 'api/UploadPic/UploadPic'
	},
	newTask: {
		preview: 'api/qcadmin/preview',
		// createorupdate:'api/qcadmin/createorupdate',
		GetAICompanys: 'api/common/GetAICompanys',
		GetDiseaseTypes: 'api/common/GetDiseaseTypes',
		GetList: 'api/qcplan/GetList',
		GetExpertGroupList: 'api/ExpertGroup/GetExpertGroupList',
		GetToDistributeInfo: 'api/qcadmin/GetToDistributeInfo',//获取待分配信息
		PostTaskDistribution: 'api/qcadmin/PostTaskDistribution',//提交分配
		ChechTaskIsDistribution: 'api/qcadmin/GetDistributionConfirm',//校验抽样任务是否分配异常
	},
	supervisor: {
		GetRegions: 'api/Region/GetRegions',
		GetHospitalAVGScore: 'api/AbilityR/GetHospitalAVGScore',
		GetHospitalUnqualifiedReport: 'api/AbilityR/GetHospitalUnqualifiedReport',
		GetDoctorsAvgScore: 'api/AbilityR/GetDoctorsAvgScore',
		GetDoctorUnqualifiedReport: 'api/AbilityR/GetDoctorUnqualifiedReport',
		GetReportList: 'api/AbilityR/GetReportList',
		GetSummary: 'api/AbilityR/GetSummary',
		GetRegionAVGScore: 'api/AbilityR/GetRegionAVGScore',
		GetRegionUnqualifiedReport: 'api/AbilityR/GetRegionUnqualifiedReport',
		GetCount: 'api/AbilityR/GetCount', //质控个数统计 获取顶部总数
		GetHospAvgScore: 'api/AbilityR/GetHospAvgScore', //影像中心排名
		GetQCedReportMonthly: 'api/AbilityR/GetQCedReportMonthly', //报告数量
		GetUnqualifiedReportMonthly: 'api/AbilityR/GetUnqualifiedReportMonthly', //医院不合格报告
		GetHospitalCount: 'api/AbilityR/GetHospitalCount', //影像中心顶部总数
		GetHospitalRadar: 'api/AbilityR/GetHospitalRadar', //医院雷达图
		GetScoreMonthly: 'api/AbilityR/GetScoreMonthly', //医院报告份数每月
		GetDoctorCount: 'api/AbilityR/GetDoctorCount', //医生获取顶部总数
		GetDoctorRadar: 'api/AbilityR/GetDoctorRadar', //医生雷达图
		GetDoctorURMonthly: 'api/AbilityR/GetDoctorURMonthly', //医生不合格报告
		GetDoctorScoreMonthly: 'api/AbilityR/GetDoctorScoreMonthly', //医生报告份数每月
		GetHospitalQCTask: 'api/AbilityR/GetHospitalQCTask', //被质控各批次-影像中心
		GetDoctorQCTask: 'api/AbilityR/GetDoctorQCTask', //被质控各批次个人
		GetDoctorsTop5AvgScore: 'api/AbilityR/GetDoctorsTop5AvgScore', //管辖下区域/医院所有医生/技师平均分排名
		GetHospitalResult: 'api/AbilityR/GetHospitalResult', //影像中心能力
		GetScoreArea: 'api/AbilityR/GetScoreArea' //影像中心分数分布
	},
	sso: {
		loginOut: 'sso/log-out' //退出到sso登录页面
	},
	dataExport: {
		getDataExportList: 'api/StatisticsData/GetAuditRandomSamplesByMonth',
		getDataExportDetails: 'api/StatisticsData/GetQualityDetailsByHospId'
	},
	//现场质控
	scene: {
		criteriaList: 'api/PadScoreCriteria/Score/Criteria/List',//评分标准列表
		criteriaAdd: 'api/PadScoreCriteria/Score/Criteria/Add', //评分标准新增
		criteriaEdit: 'api/PadScoreCriteria/Score/Criteria/Edit', //评分标准编辑
		criteriaDelete: 'api/PadScoreCriteria/Score/Criteria/Delete', //评分标准删除
		criteriaDetailsAdd: 'api/PadScoreCriteria/Score/CriteriaDetails/Add', //评分标准详情-添加
		criteriaDetailsList: 'api/PadScoreCriteria/Score/CriteriaDetails/List', //评分标准详情-列表
		criteriaDetailsDel: 'api/PadScoreCriteria/Score/CriteriaDetails/Delete', //评分标准详情-删除
		criteriaDetailsEdit: 'api/PadScoreCriteria/Score/CriteriaDetails/Edit',//评分标准详情-编辑

		imagesList: 'api/PadScoreCriteria/Score/Report/Images/List',//报告影像评分-列表
		imagesAdd: 'api/PadScoreCriteria/Score/Report/Images/Add', //报告影像评分-添加
		imagesEdit: 'api/PadScoreCriteria/Score/Report/Images/Edit', //报告影像评分-编辑
		imagesDelete: 'api/PadScoreCriteria/Score/Report/Images/Delete', //报告影像评分-删除

		patientList: 'api/PadScoreCriteria/Score/Patient/List', //患者信息字段-列表
		patientAdd: 'api/PadScoreCriteria/Score/Patient/Add', //患者信息字段-添加
		patientEdit: 'api/PadScoreCriteria/Score/Patient/Edit', //患者信息字段-编辑
		patientStateEdit: 'api/PadScoreCriteria/Score/Patient/State/Edit', //患者信息字段-状态编辑
		patientDel: 'api/PadScoreCriteria/Score/Patient/Delete',

		recordList: 'api/PadScoreCriteria/Pad/Quality/Control/Record/List', //列表
		controlDetails: 'api/PadScoreCriteria/Pad/Quality/Control/Details', //详情
		controlList: 'api/PadScoreCriteria/Pad/Quality/Control/List', //
		controlDel: 'api/PadScoreCriteria/Pad/Quality/Control/Delete', //删除
		controlEdit: 'api/PadScoreCriteria/Pad/Quality/Control/Edit', //编辑
		reportList: 'api/PadScoreCriteria/Pad/Quality/Control/Patients/Report/List', //获取现场报告影像等
		uploadImage: 'api/PadScoreCriteria/UploadImage',//图片上传
		pdfUpload: 'api/PadScoreCriteria/pc/qc/upload',//pdf上传
		approve: 'api/PadScoreCriteria/Pc/Quality/Control/Approve',//审核
		workflowAdd: 'api/PadScoreCriteria/pc/workflow/Add', //现场质控工作流程-添加
		workflowdata: 'api/PadScoreCriteria/pc/workflow/data',//现场质控工作流程-数据
		workflowEdit: 'api/PadScoreCriteria/pc/workflow/edit',//现场质控工作流程-编辑
		qcexport: 'api/PadScoreCriteria/pc/qc/export'//现场质控工作流程-导出
	}
}
export default {
	api
}
